export default {
  stripeCheckoutSessionLoadingState(state) {
    return state.checkoutSessionLoading;
  },
  stripeCheckoutSessionIdState(state) {
    return state.checkoutSessionId;
  },
};
